import { Injectable } from "@nestjs/common";
import { RouteDto } from "./dto/route.dto";
import { Route } from "./entity/route.entity";

@Injectable()
export class RouteAdapter{

    public convertDtoToEntity(routeDto : RouteDto , isUpdate : boolean = false): Route {
        const route = new Route();
        route.routeId = routeDto.routeId;
        route.routeNumber = routeDto.routeNumber;
        route.vehicleNumber = routeDto.vehicleNumber;
        route.distance = routeDto.distance;
        route.plant = routeDto.plant;
        route.pickUp = routeDto.pickUp;
        route.isActive=routeDto.isActive==undefined?true:routeDto.isActive;
        if (isUpdate) {
            route.updatedUser = routeDto.updatedUser;
          } else {
            route.isActive = true;
            route.createdUser = routeDto.createdUser;
          }
         return route;
    }

    public convertEntityToDto(routeObject:Route):RouteDto{
        const routeDto = new RouteDto;
        routeDto.routeId = routeObject.routeId;
        routeDto.routeNumber = routeObject.routeNumber;
        routeDto.vehicleNumber = routeObject.vehicleNumber;
        routeDto.distance = routeObject.distance;
        routeDto.plant = routeObject.plant;
        routeDto.pickUp = routeObject.pickUp;
        routeDto.isActive = routeObject.isActive;
        routeDto.createdAt = routeObject.createdAt;
        routeDto.updatedAt = routeObject.updatedAt;
        routeDto.createdUser = routeObject.createdUser;
        routeDto.updatedUser = routeObject.updatedUser;
        routeDto.versionFlag = routeObject.versionFlag;
        return routeDto;

    }
}